import script from "./ProductSettings.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductSettings.vue?vue&type=script&setup=true&lang=ts"

import "./ProductSettings.scss?vue&type=style&index=0&id=3c929a32&scoped=true&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c929a32"]])

export default __exports__